import React, { useCallback, useState } from 'react';
import {
  Select,
  MenuItem,
  Typography,
  SelectChangeEvent,
  Checkbox,
  OutlinedInput,
  Box,
} from '@mui/material';
import DynamicArgsWrapper from '../../containers/ArgsWarpper/ArgsWrapper';
import { MenuProps } from './constants';
import { TArgs } from '../../types/policies-types';
import { enablePoliciesSaveButton } from '../../actions/policies-selection-ui-actions/policies-selection-ui-actions';
import Chip from '@mui/material/Chip';
import { updateProfilePolicyArgs } from '../../actions/policies-profile-actions/policy-state-actions';

const MultiSelectStringArrayField: React.FC<
  React.PropsWithChildren<TArgs>
> = props => {
  const { name, label, value: initValue, range, policyId, tooltip } = props;
  const [inputValue, setInputValue] = useState<Array<string>>(
    (initValue as Array<string>) || [],
  );

  const handleChange = useCallback(
    (event: SelectChangeEvent<typeof inputValue>) => {
      const { value } = event.target;
      const updatedVal = typeof value === 'string' ? value.split(',') : value;
      setInputValue(updatedVal);
    },
    [],
  );

  const onClose = useCallback(() => {
    enablePoliciesSaveButton(true);
    updateProfilePolicyArgs({
      id: policyId,
      name,
      value: inputValue,
    });
  }, [inputValue, name, policyId]);

  return (
    <DynamicArgsWrapper meta={{ name, label, tooltip }}>
      <Select
        size='small'
        value={inputValue}
        name={name}
        label={label}
        renderValue={selected => (
          <Box
            sx={{
              display: 'flex',
              flexWrap: 'wrap',
              gap: 0.5,
              width: '100%',
            }}>
            {selected.map((value, index) => (
              <Chip
                sx={{
                  height: 'unset !important',
                }}
                variant='outlined'
                size='small'
                key={index}
                label={<Typography variant='body2'>{value}</Typography>}
              />
            ))}
          </Box>
        )}
        onChange={handleChange}
        onClose={onClose}
        input={<OutlinedInput label={label} />}
        MenuProps={MenuProps}
        sx={{
          minWidth: 218,
          paddingLeft: '2px',
        }}
        autoWidth
        multiple>
        {(range as string[]).map((item, index) => (
          <MenuItem key={index} value={item}>
            <Checkbox
              checked={(inputValue as Array<string>).indexOf(item) > -1}
            />
            <Typography variant='body2'>{item}</Typography>
          </MenuItem>
        ))}
      </Select>
    </DynamicArgsWrapper>
  );
};

export default MultiSelectStringArrayField;
